"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapListRecordItem = void 0;
var MapListRecordItem = /** @class */ (function () {
    function MapListRecordItem(_mappingTextPack) {
        this._mappingTextPack = _mappingTextPack;
        this.controller = function (feature) {
            var val = "";
            switch (feature.recordType.toLowerCase()) {
                case "mon":
                    val = "Monument";
                    break;
                case "event":
                    val = "Event";
                    break;
                case "desig":
                    val = "Designation";
                    break;
                case "cons":
                    val = "Consultation";
                    break;
            }
            return val;
        };
    }
    MapListRecordItem.prototype.getHtml = function (feature) {
        var html = "\n         <li>            \n            " + this.recordLinkHtml(feature) + "                    \n            " + this.showOnMapLinkHtml(feature) + " \n        </li>";
        return html;
    };
    MapListRecordItem.prototype.recordLinkHtml = function (feature) {
        return "\n                <a href=\"/" + this.controller(feature) + "/[uid]\" title=\"" + this._mappingTextPack.goToDetails + "\"><span><i class=\"far fa-info-circle\" aria-hidden=\"true\"></i></span></a>\n                &nbsp;\n                <a href=\"/" + this.controller(feature) + "/[uid]\" title=\"" + this._mappingTextPack.goToDetails + "\">                               \n                    <span>[name]</span>               \n                </a>\n        ";
    };
    MapListRecordItem.prototype.showOnMapLinkHtml = function (feature) {
        var layerType = feature.layerGroup.layerType;
        return "\n            <a class=\"showOnMap\" title=\"" + this._mappingTextPack.centreOnMap + "\" data-recordtype=\"" + layerType + "\" data-id=\"[uid]\">                                                \n                <i class=\"far fa-map-marked-alt fa-lg\" aria-hidden=\"true\"></i>\n            </a>\n        ";
    };
    return MapListRecordItem;
}());
exports.MapListRecordItem = MapListRecordItem;
//# sourceMappingURL=MapListRecordItem.js.map